import sharedFilters from './shared';

export default {
  pageFilters: [
    {
      id: 'content',
      label: 'Content',
      filters: {
        season: null,
        episode: null,
        show: null,
        exclude_deleted_characters: sharedFilters.exclude_deleted_characters
      }
    },
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null,
        panel: sharedFilters.sampleBalance,
        age: null,
        gender: null
      }
    },
    {
      id: 'date',
      label: 'Date',
      filters: {
        date: null
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilters.segments
      }
    }
  ],
  queries: {
    showFollowers: {
      fields: ['show', 'country', 'age', 'gender', 'panel']
    },
    showFavorites: {
      fields: [
        'country',
        'date',
        'episode',
        'season',
        'show',
        'age',
        'gender',
        'genre',
        'network',
        'panel',
        'exclude_deleted_characters'
      ]
    },
    showEmotionIndex: {
      fields: [
        'age',
        'date',
        'country',
        'episode',
        'gender',
        'season',
        'show',
        'panel'
      ]
    },
    showEpisodeEmotions: {
      fields: [
        'age',
        'country',
        'date',
        'episode',
        'gender',
        'season',
        'show',
        'panel'
      ]
    },
    showEmotionIndexMeta: {
      fields: [
        'age',
        'country',
        'date',
        'episode',
        'gender',
        'season',
        'show',
        'panel'
      ]
    },
    showEpisodeEmotionsMeta: {
      fields: [
        'age',
        'country',
        'date',
        'episode',
        'gender',
        'season',
        'show',
        'panel'
      ]
    },
    hottestMoments: {
      fields: [
        'show',
        'season',
        'episode',
        'panel',
        'age',
        'gender',
        'country',
        'date'
      ]
    },
    characterVoteEpisodeRank: {
      fields: [
        'show',
        'season',
        'episode',
        'voteRank',
        'age',
        'country',
        'gender',
        'date',
        'panel',
        'exclude_deleted_characters'
      ]
    },
    engagementRawTotals: {
      fields: [
        'age',
        'country',
        'date',
        'episode',
        'gender',
        'season',
        'show',
        'panel'
      ]
    }
  }
};
